import Aceite from './Aceite';

export default Aceite;
